export function DottedSquareSparkleIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3H6.5V5H5V6.5H3V3ZM14.5 5H9.5V3H14.5V5ZM19 5H17.5V3H21V6.5H19V5ZM5 9.5V14.5H3V9.5H5ZM19 14.5V9.5H21V14.5H19ZM5 19V17.5H3V21H6.5V19H5ZM19 19V17.5H21V21H17.5V19H19ZM9.5 19H14.5V21H9.5V19Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.95943 9.95943L11.0513 6.68377H12.9487L14.0406 9.95943L17.3162 11.0513V12.9487L14.0406 14.0406L12.9487 17.3162H11.0513L9.95943 14.0406L6.68377 12.9487V11.0513L9.95943 9.95943ZM12 10.1623L11.6987 11.0662L11.0662 11.6987L10.1623 12L11.0662 12.3013L11.6987 12.9338L12 13.8377L12.3013 12.9338L12.9338 12.3013L13.8377 12L12.9338 11.6987L12.3013 11.0662L12 10.1623Z"
        fill="currentColor"
      />
    </svg>
  );
}
